import type { ReactNode } from 'react'
import React from 'react'

import * as S from './styled'

type Props = {
  title: string
  button: ReactNode
  emptyMessage?: string
  children?: ReactNode
}

export const EventsSection = ({ title, button, emptyMessage, children }: Props) => {
  return (
    <div>
      <S.Header>
        <S.Title>{title}</S.Title>
        <div>{button}</div>
      </S.Header>
      <S.Content maxHeight={220}>
        {emptyMessage ? <S.EmptyMessage>{emptyMessage}</S.EmptyMessage> : children}
      </S.Content>
    </div>
  )
}
